module.exports = __webpack_public_path__ + "static/media/icn-edit.9bc4af0b.svg";